export interface Options {
    name?: string;
    priority?: number;
    callback: Callback;
    blocking?: boolean;
}
interface Callback {
    (): void;
}

export default class LayerProxy {
    private name = 'unnamed';
    private priority = 1;
    private callback: Callback;
    private blocking = true;

    private callbackCalled = false;

    constructor(opts: Options) {
        this.callbackCalled = false;
        this.setOptions(opts);
    }

    setOptions(options: Options) {
        if (options.name) {
            this.setName(options.name);
        }
        if (options.callback) {
            this.setCallback(options.callback);
        }
        if (options.priority) {
            this.setPriority(options.priority);
        }
        if (typeof options.blocking !== 'undefined') {
            this.setBlocking(options.blocking);
        }
    }

    setName(name: string) {
        this.name = name;
    }

    setCallback(callback: Callback) {
        if (typeof callback === 'function') {
            this.callback = callback;
        }
    }

    setPriority(priority: number) {
        this.priority = priority;
    }

    setBlocking(block: boolean) {
        this.blocking = block;
    }

    getName() { return this.name; }

    getCallback() { return this.callback; }

    getPriority() { return this.priority; }

    getBlocking() { return this.blocking; }

    runCallback(force = false) {
        if (this.callbackCalled && !force) {
            return;
        }
        this.callback();
        this.callbackCalled = true;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/autolayermanager/LayerProxy.ts
 **/